'use client';

import { useTranslation } from 'react-i18next';
import { AppAuthLoader } from '@/components/AppGateShell';
import { initPanelI18n } from '@/lib/panel-i18n/panelI18n';

// Ensure i18n is ready even if this module is SSR'd before PanelI18nRoot effects.
initPanelI18n();

export default function PanelSessionLoader({ variant = 'user' }) {
  const { t } = useTranslation('panel');
  const isAgent = variant === 'agent';
  return (
    <AppAuthLoader
      title={isAgent ? t('auth.gate.agentTitle') : t('auth.gate.userTitle')}
      description={isAgent ? t('auth.gate.agentDescription') : t('auth.gate.userDescription')}
    />
  );
}
